export function preloadImages(urls: string[]) {
  const images = [];
  for (let i = 0; i < urls.length; i++) {
    const img = new Image();
    img.src = urls[i];
    images.push(img);
  }
  return images;
}
